import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const IMG_MAP: any = {
        us: '',
        au: '_au',
        kr: '_kr',
    };
    const data: BannerType = {
        src: `/responsive/picture/power-backup/1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
        srcPad: `/responsive/picture/power-backup/1_pad${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
        srcMobile: `/responsive/picture/power-backup/1_${locale === 'kr' ? 'pad' : 'mobile'}${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        btnText: t('secA_btn'),
        link: '#power-backup-D',
    };
    return (
        <div className={`power-backup-A ${css['power-backup-A']}`}>
            <BannerStatic {...data} />
        </div>
    );
}
